{% block ecocode_trustpilot_overview_view %}
    <div>
            <h4>{{ $tc('ecocode-trustpilot.invitation.modalTitle') }}</h4>
            <sw-number-field
                :label="$tc('ecocode-trustpilot.invitation.daysLabel')"
                numberType="int"
                :min="1"
                :max="90"
                v-model:value="days"
                validation="required"
                required
            >
            </sw-number-field>
            <p>
                {{ $tc('ecocode-trustpilot.invitation.modalBody', {days,ordersCount}) }}
            </p>
    </div>
{% endblock %}
